import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BrazilFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14414'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14414)'>
				<rect
					width='20'
					height='14'
					fill='#05AB41'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.79217 7.56305C2.3793 7.30124 2.3793 6.69883 2.79217 6.43702L9.64252 2.09309C9.86047 1.95488 10.1386 1.95488 10.3566 2.09309L17.2069 6.43702C17.6198 6.69883 17.6198 7.30124 17.2069 7.56305L10.3566 11.907C10.1386 12.0452 9.86047 12.0452 9.64252 11.907L2.79217 7.56305Z'
					fill='#FDD216'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99935 10.2666C11.8403 10.2666 13.3327 8.80407 13.3327 6.99994C13.3327 5.19581 11.8403 3.73328 9.99935 3.73328C8.1584 3.73328 6.66602 5.19581 6.66602 6.99994C6.66602 8.80407 8.1584 10.2666 9.99935 10.2666Z'
					fill='#053087'
				/>
				<mask
					id='mask1_2332_14414'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='6'
					y='3'
					width='8'
					height='8'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.99935 10.2666C11.8403 10.2666 13.3327 8.80407 13.3327 6.99994C13.3327 5.19581 11.8403 3.73328 9.99935 3.73328C8.1584 3.73328 6.66602 5.19581 6.66602 6.99994C6.66602 8.80407 8.1584 10.2666 9.99935 10.2666Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_14414)'>
					<path
						d='M6.27154 6.14616C6.7949 5.73083 8.48373 6.12428 10.0602 6.5364C11.6367 6.94852 13.2809 7.81233 13.6995 8.31897'
						stroke='white'
						strokeWidth='1.33333'
						strokeLinecap='square'
					/>
				</g>
			</g>
		</svg>
	);
};

export default BrazilFlagIcon;
